import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
type PropsTye = {
  children: any;
  onShowToggle: (t: string, isSectionOpening: boolean) => void;
  sectionTitle?: string;
  visibleSection?: any;
};
const SectionContainer = (props: PropsTye) => {
  const { children, onShowToggle, sectionTitle, visibleSection } = props;
  const [showContent, setshowContent] = useState(false);

  const onToggleShow = () => {
    const isSectionOpening = !showContent;
    setshowContent(isSectionOpening);
    onShowToggle(sectionTitle || "", isSectionOpening);
  };

  useEffect(() => {
    setshowContent(visibleSection === sectionTitle);
  }, [visibleSection]);

  return (
    <SectionContainerWrapper className="mx-1 mt-1">
      <button
        className="d-flex flex-grow-1 p-2 bg-light justify-content-between sectionbutton"
        onClick={onToggleShow}
      >
        <p className="md-text">{sectionTitle || "Section Title"}</p>
        <div>{!showContent ? <BsChevronDown /> : <BsChevronUp />}</div>
      </button>
      {showContent && <div className="p-1 bg-white border">{children}</div>}
    </SectionContainerWrapper>
  );
};

export default SectionContainer;

const SectionContainerWrapper = styled.div`
  .sectionbutton {
    width: 100%;
    outline: none;
    border: none;
  }
`;
